"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.reduxSet = exports.INITIAL_STATE = exports.ACTIONS = void 0;
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const summithill_models_1 = require("@clearsummit/summithill-models");
const immer_1 = __importDefault(require("immer"));
const schema_1 = require("./schema");
const shared_reducers_1 = require("./shared-reducers");
exports.ACTIONS = {
    GET_PROGRAM_SUCCESS: 'PROGRAM/GET_PROGRAM_SUCCESS',
    GET_SECTIONS_SUCCESS: 'PROGRAM/GET_SECTIONS_SUCCESS',
    SET_VIDEO_STATE_SUCCESS: 'PROGRAM/SET_VIDEO_STATE_SUCCESS',
    SET_PROCESS_QUESTION_SUCCESS: 'SET_PROCESS_QUESTION_SUCCESS',
    LIST_PROGRAMS_REQUEST: 'PROGRAM/LIST_PROGRAMS_REQUEST',
    LIST_PROGRAMS_SUCCESS: 'PROGRAM/LIST_PROGRAMS_SUCCESS',
    LIST_PROGRAMS_FAILURE: 'PROGRAM/LIST_PROGRAMS_FAILURE',
    LIST_SECTIONS_SIMPLE_FAILURE: "PROGRAM/LIST_SECTIONS_SIMPLE_FAILURE",
    LIST_SECTIONS_SIMPLE_SUCCESS: "PROGRAM/LIST_SECTIONS_SIMPLE_SUCCESS",
    GET_USER_SESSION_SUCCESS: "PROGRAM/GET_USER_SESSION_SUCCESS",
    GET_USER_SESSION_FAILURE: "PROGRAM/GET_USER_SESSION_FAILURE",
    CREATE_PROGRAM_SUCCESS: "PROGRAM/CREATE_PROGRAM_SUCCESS",
    CREATE_PROGRAM_FAILURE: "PROGRAM/CREATE_PROGRAM_FAILURE",
    GET_PROGRAM_DETAIL_SUCCESS: "PROGRAM/GET_PROGRAM_DETAIL_SUCCESS",
    CREATE_SECTION_SUCCESS: "PROGRAM/CREATE_SECTION_SUCCESS",
    CREATE_SECTION_FAILURE: "PROGRAM/CREATE_SECTION_FAILURE",
    EDIT_SECTION_SUCCESS: "PROGRAM/EDIT_SECTION_SUCCESS",
    EDIT_SECTION_FAILURE: "PROGRAM/EDIT_SECTION_FAILURE",
    DELETE_ADMIN_PROGRAM_SUCCESS: "PROGRAM/DELETE_ADMIN_PROGRAM_SUCCESS",
    DELETE_ADMIN_PROGRAM_FAILURE: "PROGRAM/DELETE_ADMIN_PROGRAM_FAILURE",
    DELETE_ADMIN_SECTION_SUCCESS: "PROGRAM/DELETE_ADMIN_SECTION_SUCCESS",
    DELETE_ADMIN_SECTION_FAILURE: "PROGRAM/DELETE_ADMIN_SECTION_FAILURE",
    CLEAR_ADMIN_SECTION: "PROGRAM/CLEAR_ADMIN_SECTION",
};
exports.INITIAL_STATE = {
    programs: {},
    sections: {},
    sectionContents: {},
    pendingAdminPrograms: false,
    adminPrograms: [],
    simpleSections: [],
    userSession: null,
    adminProgram: null,
    adminSection: null
};
const setProcessQuestionSuccess = immer_1.default((draft, payload) => {
    const state = draft;
    if (payload === null || payload === void 0 ? void 0 : payload.data) {
        const { data: { processquestion }, meta: { programId, sectionId } } = payload;
        state.sections[programId].data[sectionId].entities.processquestions[processquestion.id] = processquestion;
    }
});
const getProgramSuccess = immer_1.default((draft, payload) => {
    const state = draft;
    if (payload) {
        const { program } = payload.data;
        state.programs[program.id] = program;
    }
});
const getSectionsSuccess = immer_1.default((draft, payload) => {
    var _a;
    const state = draft;
    if (payload) {
        const { meta, data } = payload;
        const { id: programId, page } = meta;
        const { data: d, next, previous, count, } = data;
        const { sections = {} } = schema_1.sectionsNormalizer(d);
        const pagedData = {
            data: {},
            meta: {
                count: 0, next: '', previous: '',
            },
        };
        pagedData.data = page && page > 1 ? Object.assign(Object.assign({}, ((_a = state.sections[programId]) === null || _a === void 0 ? void 0 : _a.data) || {}), sections) : sections;
        pagedData.meta = {
            count, next, previous,
        };
        state.sections[programId] = pagedData;
    }
});
const setVideoStateSuccess = immer_1.default((draft, payload) => {
    const state = draft;
    if (payload) {
        const { data: { video }, meta: { programId, sectionId, videoId } } = payload;
        state.sections[programId].data[sectionId].entities.videos[videoId] = video;
    }
});
const listProgramsRequest = (state) => (Object.assign(Object.assign({}, state), { pendingAdminPrograms: true }));
const listProgramsSuccess = (state, payload) => {
    const { data } = payload;
    return (Object.assign(Object.assign({}, state), { pendingAdminPrograms: false, adminPrograms: data === null || data === void 0 ? void 0 : data.data.map((p) => new summithill_models_1.Program(p)) }));
};
const listProgramsFailure = (state) => (Object.assign(Object.assign({}, state), { pendingAdminPrograms: false }));
const listSectionsSimpleSuccess = (state, payload) => {
    const { data } = payload;
    return (Object.assign(Object.assign({}, state), { simpleSections: data === null || data === void 0 ? void 0 : data.results.map((s) => new summithill_models_1.Section(s)) }));
};
const getUserSessionSuccess = (state, payload) => (Object.assign(Object.assign({}, state), { userSession: payload === null || payload === void 0 ? void 0 : payload.data }));
const getProgramDetailSuccess = (state, payload) => (Object.assign(Object.assign({}, state), { adminProgram: payload.data }));
// MANAGE PROGRAMS
// @ts-ignore
const deleteAdminProgramSuccess = (state) => (Object.assign(Object.assign({}, state), { adminProgram: null }));
const createAdminSectionSuccess = (state, payload) => (Object.assign(Object.assign({}, state), { adminSection: payload.data }));
const editAdminSectionSuccess = (state, payload) => (Object.assign(Object.assign({}, state), { adminSection: payload.data }));
const clearAdminSection = (state, order) => (Object.assign(Object.assign({}, state), { adminSection: state.adminSection.order === order ? null : state.adminSection }));
const deleteAdminSectionSuccess = (state, payload) => {
    var _a;
    const { meta } = payload;
    return Object.assign(Object.assign({}, state), { adminProgram: Object.assign(Object.assign({}, state.adminProgram), { sections: (_a = state.adminProgram) === null || _a === void 0 ? void 0 : _a.sections.filter((s) => (s === null || s === void 0 ? void 0 : s.id) !== (meta === null || meta === void 0 ? void 0 : meta.id)) }) });
};
exports.reduxSet = {
    getProgramSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.GET_PROGRAM_SUCCESS, getProgramSuccess),
    getSectionsSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.GET_SECTIONS_SUCCESS, getSectionsSuccess),
    setVideoStateSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.SET_VIDEO_STATE_SUCCESS, setVideoStateSuccess),
    setProcessQuestionSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.SET_PROCESS_QUESTION_SUCCESS, setProcessQuestionSuccess),
    listProgramsRequest: radio_dispatch_1.dispatchReducer(exports.ACTIONS.LIST_PROGRAMS_REQUEST, listProgramsRequest),
    listProgramsSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.LIST_PROGRAMS_SUCCESS, listProgramsSuccess),
    listProgramsFailure: radio_dispatch_1.dispatchReducer(exports.ACTIONS.LIST_PROGRAMS_FAILURE, listProgramsFailure),
    listSectionsSimpleSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.LIST_SECTIONS_SIMPLE_SUCCESS, listSectionsSimpleSuccess),
    listSectionsSimpleFailure: radio_dispatch_1.dispatchReducer(exports.ACTIONS.LIST_SECTIONS_SIMPLE_FAILURE, shared_reducers_1.noOp),
    getUserSessionSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.GET_USER_SESSION_SUCCESS, getUserSessionSuccess),
    getUserSessionFailure: radio_dispatch_1.dispatchReducer(exports.ACTIONS.GET_USER_SESSION_FAILURE, shared_reducers_1.noOp),
    createProgramSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.CREATE_PROGRAM_SUCCESS, shared_reducers_1.noOp),
    createProgramFailure: radio_dispatch_1.dispatchReducer(exports.ACTIONS.CREATE_PROGRAM_FAILURE, shared_reducers_1.noOp),
    getProgramDetailSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.GET_PROGRAM_DETAIL_SUCCESS, getProgramDetailSuccess),
    createSectionSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.CREATE_SECTION_SUCCESS, createAdminSectionSuccess),
    createSectionFailure: radio_dispatch_1.dispatchReducer(exports.ACTIONS.CREATE_SECTION_FAILURE, shared_reducers_1.noOp),
    editSectionSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.EDIT_SECTION_SUCCESS, editAdminSectionSuccess),
    editSectionFailure: radio_dispatch_1.dispatchReducer(exports.ACTIONS.EDIT_SECTION_FAILURE, shared_reducers_1.noOp),
    deleteAdminProgramSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.DELETE_ADMIN_PROGRAM_SUCCESS, deleteAdminProgramSuccess),
    deleteAdminProgramFailure: radio_dispatch_1.dispatchReducer(exports.ACTIONS.DELETE_ADMIN_PROGRAM_FAILURE, shared_reducers_1.noOp),
    deleteAdminSectionSuccess: radio_dispatch_1.dispatchReducer(exports.ACTIONS.DELETE_ADMIN_SECTION_SUCCESS, deleteAdminSectionSuccess),
    deleteAdminSectionFailure: radio_dispatch_1.dispatchReducer(exports.ACTIONS.DELETE_ADMIN_SECTION_FAILURE, shared_reducers_1.noOp),
    clearAdminSection: radio_dispatch_1.dispatchReducer(exports.ACTIONS.CLEAR_ADMIN_SECTION, clearAdminSection)
};
const reducer = (state = exports.INITIAL_STATE, action) => radio_dispatch_1.runReducers(state, action, exports.reduxSet);
exports.reducer = reducer;
